import React, { Component } from 'react';
import styled from 'styled-components';
import { changeLocation } from 'api/Location';

import WelcomeChecklist from '../components/welcome/WelcomeChecklist';

// Instructor welcome is a single consolidated checklist page at
// /instructor/welcome (used for all rounds). The legacy
// multi-page wizard files (welcome/step1..4, game-overview/*,
// setting-up-gameplay/*, how-grading-works/*, what-to-expect/step1,
// what-to-expect/step5, how-we-support-you, next-steps) are kept on
// disk in case we need to bring any content back, but they are no
// longer mounted as routes.
//
// The three round-specific What-to-Expect components (step2/3/4)
// are imported and rendered as popups inside WelcomeChecklist.
//
// Any URL under /instructor/welcome/... gets normalized to the
// single welcome page so deep-links to the old wizard pages don't
// 404 silently — they just land on the checklist.

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
`;

class InstructorWelcomePage extends Component {

  componentDidMount() {
    this.normalizeLocation();
  }

  componentDidUpdate() {
    this.normalizeLocation();
  }

  // Redirects any legacy wizard sub-paths under /instructor/welcome/
  // back to the single welcome page. Idempotent: skipped if we're
  // already on /instructor/welcome.
  normalizeLocation = () => {
    const { location } = this.props;
    if (!location || !location.pathname) return;
    const target = '/instructor/welcome';
    if (location.pathname === target) return;
    if (location.pathname.indexOf('/instructor/welcome') !== 0) return;
    changeLocation(`${target}?round=${this.activeRound}`);
  };

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;
    return roundInUrl || currentRound;
  }

  render() {
    const { rounds, currentRound, roundInUrl } = this.props;
    return (
      <Wrapper>
        <Content>
          <WelcomeChecklist
            currentRound={currentRound}
            roundInUrl={roundInUrl}
            rounds={rounds}
          />
        </Content>
      </Wrapper>
    );
  }

}

export default InstructorWelcomePage;



// WEBPACK FOOTER //
// ./src/instructor/containers/welcome.js